import React from 'react'
import { errorMessage } from '../../constants/errorMessage'

export const renderNoResults = (error) => {

    const message = error ? error : errorMessage?.noDataAvailable
    return (
      <div className='no-results text-center m-2'>
        <p className='mb-0 alert alert-danger'>{message}</p>
      </div>
    )
  }